<template lang="pug">
    div
        v-progress-linear(v-if="loading" :indeterminate="true")
        div(v-else-if="page" v-html="$showLocalizedField(page.content, locale).text")
</template>


<script>
    import { pagesService } from '@/_services'
    import { mapState } from "vuex";
    export default {
        mounted () {
            this.loadPage(this.$route.params.alias)
        },
        beforeRouteUpdate (to, from, next) {
            this.loadPage(to.params.alias)
            next()
        },
        computed: {
            ...mapState(['locale'])
        },
        methods: {
            loadPage(alias){
                this.loading = true
                pagesService.get(alias).then(data => {
                    this.page = data
                    this.setPageTitle()
                    this.loading = false
                })
            },
            setPageTitle(){
                let defaultTitle = this.page.title[0].text
                defaultTitle = this.page.title.find(t => t.locale === this.locale).text || defaultTitle;
                document.title = defaultTitle;
            }
        },
        watch: {
            locale: function(){
                this.setPageTitle()
            }
        },
        data() {
            return {
                loading:false,
                page:null
            }
        }
    }
</script>